// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__q-+N-","heroBox":"Hero_heroBox__J1rE3","firstChild":"Hero_firstChild__UDWAI","secondChild":"Hero_secondChild__cx75N","thirdChild":"Hero_thirdChild__lSysp"};